var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Dashboard"}},_vm._l((_vm.cardsData),function(cardRow){return _c('DashboardCard',{key:cardRow[0].title,attrs:{"cardRowData":cardRow}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }